import KomentarRapor from "../../../../../components/categories/siakad/lms/rapor/subpage/kategori_komentar/Home";
export default function Home() {
  
  return (
    <KomentarRapor />
  );
}
